import api from './axiosApi'

export interface UndoStackEntry {
  id: string
  change_type: string
  description: string
  created_at: string
}

export interface UndoStackResponse {
  entries: UndoStackEntry[]
}

export interface UndoResult {
  undone: boolean
  description: string
}

/**
 * Fetch the current user's undoable plan-header changes.
 * GET /plans/{plan_id}/undo-stack
 */
export async function fetchPlanUndoStack(
  planId: string
): Promise<UndoStackResponse> {
  const response = await api.get<UndoStackResponse>(
    `/plans/${planId}/undo-stack`
  )
  return response.data
}

/**
 * Undo the current user's most recent plan-header change.
 * POST /plans/{plan_id}/undo
 */
export async function undoPlanChange(planId: string): Promise<UndoResult> {
  const response = await api.post<UndoResult>(`/plans/${planId}/undo`)
  return response.data
}
